import api from './api';
import {AppResponse} from "../models/common/app-response";
import { MedicTableViewDto } from '../models/medics/medicTableViewDto';
import { PaginatedResponse } from '../models/common/paginated-response';
import { MedicFilter } from '../models/medics/medicFilter';
import { MedicDetailsDto } from '../models/medics/medicDetailsDto';
import { AddMedicDto } from '../models/medics/addMedicDto';
import { FormDataUtils } from '../helpers/formDataUtils';
import { EditMedicDto } from '../models/medics/editMedicDto';
import { MedicDigitalSignDto, SetDefaultCertificateDto } from '../models/medics/medicDigitalSignDto';
import { TokenType } from '../models/enums/tokenType';

class MedicsService {

    baseUrl: string = "/api/v1/medics";

    /**
     * Получение сертификата медика.
     * @param tokenType - Опциональный фильтр по типу токена (Cloud или Physical). Если не указан, возвращается сертификат по умолчанию.
     */
    getMedicCertificate = (tokenType?: TokenType) => {
        const params: any = {};
        if (tokenType !== undefined) {
            params.tokenType = tokenType;
        }
        return api
            .get<AppResponse<MedicDigitalSignDto | null>>(`${this.baseUrl}/my/certificate`, { params })
            .then((res) => res.data?.data ?? null);
    }

    /**
     * Получение активных сертификатов медика
     * @param tokenType - Опциональный фильтр по типу токена
     * @param isDefault - Опциональный фильтр по флагу isDefault
     */
    getActiveCertificates = (tokenType?: TokenType, isDefault?: boolean) => {
        const params: any = {};
        if (tokenType !== undefined) {
            params.tokenType = tokenType;
        }
        if (isDefault !== undefined) {
            params.isDefault = isDefault;
        }
        return api.get<AppResponse<MedicDigitalSignDto[]>>(`${this.baseUrl}/my/certificates`, { params }).then((data) => data.data.data);
    }

    /**
     * Установка сертификата по умолчанию
     */
    setDefaultCertificate = (data: SetDefaultCertificateDto) => {
        return api.post<AppResponse<MedicDigitalSignDto>>(`${this.baseUrl}/my/default-certificate`, data).then((data) => data.data.data);
    }

    /**
     * Сохранение информации о сертификате (при подписании)
     */
    saveCertificate = (data: SetDefaultCertificateDto & { isDefault?: boolean }) => {
        return api.post<AppResponse<MedicDigitalSignDto>>(`${this.baseUrl}/my/certificate`, data).then((data) => data.data.data);
    }

    getByFilter = (filter?: MedicFilter) => {
        return api.get<AppResponse<PaginatedResponse<MedicTableViewDto>>>(this.baseUrl, { params: filter });
    }

    getById = (id: number) => {
        return api.get<AppResponse<MedicDetailsDto>>(`${this.baseUrl}/${id}`);
    }

    add = (data: AddMedicDto) => {
        const formData = FormDataUtils.toFormData(data);
        return api.post<AppResponse<number>>(this.baseUrl, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    }

    edit = (data: EditMedicDto) => {
        const formData = FormDataUtils.toFormData(data);
        return api.put<AppResponse<number>>(`${this.baseUrl}/${data.id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    }

    dismiss(id: number) {
        return api.patch<AppResponse<number>>(`${this.baseUrl}/${id}/dismiss`);
    }
}

export const medicsService = new MedicsService();